// removed by extract-text-webpack-plugin
module.exports = {"content":"_2Xqi7w-eQHw81Nj3Q6Xrx-","title":"T8qmVd9LyqMZOyOwSySXU","cardBox":"_1RBJe-zGkXG830yWFLwDNy","fadein":"_2N9TTv4o7kD1v7pqe67dVf","exiting":"_3MERfUtBN_R1yMUOPrVS_x","exited":"_1GPn28UfDrSBvLjXMbQtL","spacer":"_14bg-zmeSqAUmpWbQgHN1F","dashboardBox":"_1Vb6mGp0TtzC9q1n04DMPl","dashboardName":"ykMg--_Tn2Z27XOtahbqR","fields":"_2zdnyZJpZBmAKL3aP6Bvzn","field":"_2mjO0rMaNxua-9ZSu2h_TD","gridItem":"_1dkhB-NYHEow2OlejqMMQ6","gridItemCard":"_3IoIvS29OuNCZmfM-r31Vg"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/DashboardConfig/style.scss
// module id = 633
// module chunks = 0